import { OrderStatus } from '@imcc/transport';

export const DONE_STATUSES: OrderStatus[] = [
  OrderStatus.completed,
  OrderStatus.archived,
  OrderStatus.failed,
];
